export const userRoles = {
    owner: "Owner",
    admin: "Admin",
    hr: "HR",
    mod: "Mod",
    user: "User"
}